module.exports = __webpack_public_path__ + "img/ship_management.942014d5.svg";